export default __webpack_public_path__ + "static/media/933.a82d2624.gif";